import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var RefreshCw02 = function RefreshCw02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M2 14s.1213.8492 3.636 4.364c3.5148 3.5147 9.2132 3.5147 12.728 0 1.2452-1.2453 2.0493-2.7647 2.4122-4.364M2 14v6m0-6h6m14-4s-.1213-.8492-3.636-4.364c-3.5148-3.5147-9.2132-3.5147-12.728 0C4.3908 6.8813 3.5867 8.4007 3.2238 10M22 10V4m0 6h-6"
    })
  }));
};
export default RefreshCw02;